import { IBuyer } from './buyer'
import { ISeller } from './seller'
import { ISalesOfficer } from './salesOfficer'
import { IProduct } from './product'
import { IManufacturer } from './manufacturer'
import { Dispatch } from 'react'

interface OrderCharge {
  _id?: string
  tag: string
  value: number
  meta: string
  order_group_id: string
  title: string
  index: number

  created?: number
  modified?: number
}

export enum OrderTag {
  Pending = 'pending',
  Completed = 'completed',
  Cancelled = 'cancelled',
  Deleted = 'deleted',
  Draft = 'draft',
}

export enum DeliveryStatus {
  DeliveredOnTime = 'delivered_on_time',
  DeliveredLate = 'delivered_late',
  NotDelivered = 'not_delivered',
}

export enum DeliveryIssue {
  CustomerUnavailable = 'customer_unavailable',
  RepVanUnavailable = 'rep_van_unavailable',
  OrderRejected = 'order_rejected',
  ProductUnavailable = 'product_unavailable',
}

export enum DeliveryHandler {
  Betty = 'betty',
  Suplias = 'suplias',
}

export interface IOrder {
  _id?: string
  ref: string

  tag: OrderTag
  amount: number

  created?: number
  modified?: number

  order_group_ref?: string

  buyer?: IBuyer
  sales_officer?: ISalesOfficer
  sales_officer_id?: string

  seller?: ISeller
  seller_id?: string

  manufacturer?: IManufacturer
  manufacturer_id?: string

  meta?: any

  /** For order groups */
  orders?: any
  charges?: OrderCharge
}

export interface IOrderItem {
  _id?: string

  order_id: string
  product?: IProduct
  product_id: string

  amount: number
  quantity: number

  /** For order group items */
  order_group_id?: string
}

export interface IOrderGroup extends IOrder {
  orders?: any
  charges?: OrderCharge

  is_latest?: boolean
}

export interface IOrderGroupItem extends IOrderItem {
  order_group_id?: string
}

export enum OrderContextActionTypes {
  set = 'SET_ORDER_GROUP',
  add = 'ADD_ORDER_GROUP',
  remove = 'REMOVE_ORDER_GROUP',
  clear = 'CLEAR_ALL'
}

export type OrderContextActions =
  | { type: OrderContextActionTypes.clear }
  | {
    type: OrderContextActionTypes.set,
    payload: IOrderGroup[]
  }
  | {
    type: OrderContextActionTypes.add,
    payload: IOrderGroup
  }
  | {
    type: OrderContextActionTypes.remove,
    payload: string
  }

export interface IOrderContextState {
  order_group: IOrderGroup[],
  order_group_pending: IOrderGroup[],
  order_group_cancelled: IOrderGroup[],
  order_group_completed: IOrderGroup[],
  latest_order: IOrderGroup | null,
  loading: boolean,
  error: any,
}

export interface IOrderContextValue {
  state: IOrderContextState,
  dispatch: Dispatch<OrderContextActions>,
  action: any
}